import { ContactMessageDialog, type ContactMessageTarget } from './ContactMessageDialog';

export type ProspectMessage = ContactMessageTarget & {
  contact_name: string;
  product_interest?: string;
  opportunity?: string;
  message?: string;
  notes?: string;
};

type Props = {
  prospect: ProspectMessage;
  onClose: () => void;
};

function displayName(p: ProspectMessage) {
  const n = `${p.first_name ?? ''} ${p.last_name ?? ''}`.trim();
  return n || p.contact_name;
}

export function ProspectMessageDialog({ prospect, onClose }: Props) {
  const first = prospect.first_name || prospect.contact_name.split(/\s+/)[0] || '';
  const interest = prospect.product_interest || prospect.opportunity || '';
  const message = (prospect.message || prospect.notes || '').trim();

  return (
    <ContactMessageDialog
      contact={{
        first_name: prospect.first_name || prospect.contact_name.split(/\s+/)[0] || '',
        last_name: prospect.last_name || prospect.contact_name.split(/\s+/).slice(1).join(' '),
        email: prospect.email,
        phone: prospect.phone,
        location: prospect.location,
        company: prospect.company,
      }}
      title="Message marketplace"
      subtitle={`Demande reçue via la marketplace · ${displayName(prospect)}`}
      contextTitle={interest || message ? 'Besoins exprimés' : undefined}
      contextHighlight={interest || undefined}
      contextBody={message || undefined}
      defaultReply={`Bonjour ${first},\n\nSuite à votre demande, je vous contacte afin de...\n\nCordialement`}
      onClose={onClose}
    />
  );
}
